<template>
  <div class="group-setup">
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2  orange--text">Project Documents</h3>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-row>
        <v-col cols="12" v-if="data">
          <DocumentList :documents="data.documents" @deleteDocument="deleteDocument($event)"></DocumentList>
        </v-col>
      </v-row>

      <v-divider></v-divider>
    </v-card>
  </div>
</template>

<script>
import DocumentList from "../child/DocumentList";

export default {
  name: "groupSetUpFrom",
  props: ["data"],
  components: { DocumentList },

  data: () => ({}),

  mounted() { },

  methods: {},
};
</script>
